<script setup lang="ts">
import { useDefaultLegend } from "@/components/legends/configurator/edit-legend.models";
import LegendConfigurator from "@/components/legends/configurator/LegendConfigurator.vue";
import { useCreateLegend } from "@/stores/queries";
import type { WithoutID } from "@/types/generic.types";
import type { Legend } from "@/types/legend.types";
import { useRouter } from "vue-router";

const defaultLegend = useDefaultLegend();

const router = useRouter();

const { mutateAsync: createLegendMutation, isPending } = useCreateLegend();
const backToLegends = () => {
  router.push({ name: "settings-legends" });
};

const handleCreate = (newLegend: WithoutID<Legend>) => {
  createLegendMutation(newLegend, {
    onSuccess: () => {
      backToLegends();
    },
  });
};
</script>

<template>
  <div class="mb-5 mx-3 mx-md-4 mx-lg-5 px-sm-2 px-md-4 px-lg-5">
    <LegendConfigurator
      :loading="isPending"
      :legend="defaultLegend"
      :confirm-label="$t('dashboard:save.legend')"
      @save="handleCreate"
      @back="backToLegends"
    />
  </div>
</template>

<style lang="scss" scoped></style>
